import React from "react";

const RenderAmount = ({ value: x, style }) => (
  <div className="numeric" style={style}>
    {x || x === 0
      ? x.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : ""}
  </div>
);

export default RenderAmount;
